import React, { Component } from 'react';
import Modal, { ModalHeader, ModalBody } from '../Modal';
import localize from '../localize';
import './HelpModal.css';

export class HelpButtonBare extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false
    };
  }

  handleModalOpen() {
    this.setState({
      isModalOpen: true
    });
  }

  handleModalClose() {
    this.setState({
      isModalOpen: false
    });
  }

  render() {
    const { i18n } = this.props;
    return (
      <div className="help-button">
        <span className="question-icon" onClick={() => this.handleModalOpen() } />
        <Modal isOpen={this.state.isModalOpen} className="helpModal" contentLabel="Modal" handleModalClose={() => this.handleModalClose()} onRequestClose={() => this.handleModalClose()}>
          <ModalHeader>
            <header>
              <h1>{i18n.t('header')}</h1>
              <h2>{i18n.t('subheader')}</h2>
            </header>
          </ModalHeader>
          <ModalBody>
            <div className="content">
              <div className="content-section">
                <div className="content-section-header">{i18n.t('isp_score')}</div>
                <div className="content-subsection">
                  <div className="subsection-header">{i18n.t('your_isp.header')}</div>
                  <div>{i18n.t('your_isp.body')}</div>
                </div>
                <div className="content-subsection">
                  <div className="subsection-header">{i18n.t('best_isp.header')}</div>
                  <div>{i18n.t('best_isp.body')}</div>
                </div>
                <div className="content-subsection">
                  <div className="subsection-header">{i18n.t('breakdown.header')}</div>
                  <div>
                    <span className="bracket bracket-great">{i18n.t('breakdown.great')}</span>
                    <span className="bracket bracket-good">{i18n.t('breakdown.good')}</span>
                    <span className="bracket bracket-ok">{i18n.t('breakdown.ok')}</span>
                    <span className="bracket bracket-poor">{i18n.t('breakdown.poor')}</span>
                  </div>
                </div>
              </div>
              <div className="content-section">
                <div className="content-section-header">{i18n.t('metrics.about')}</div>
                <div className="content-subsection">
                  <div className="subsection-header">{i18n.t('metrics.packet_loss.header')}</div>
                  <div>{i18n.t('metrics.packet_loss.body')}</div>
                </div>
                <div className="content-subsection">
                  <div className="subsection-header">{i18n.t('metrics.jitter.header')}</div>
                  <div>{i18n.t('metrics.jitter.body')}</div>
                </div>
                <div className="content-subsection">
                  <div className="subsection-header">{i18n.t('metrics.latency.header')}</div>
                  <div>{i18n.t('metrics.latency.body')}</div>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default localize()(HelpButtonBare);



// WEBPACK FOOTER //
// ./src/components/HelpModal/index.js